<template>
    <div class="full_container">
        <div class="container">
            <CommonBreadcrumb class="my-3" />
        </div>
        <div class="video_box">
            <!-- <video src="~/assets/landing/about/about_Us.mp4"></video> -->
            <video @contextmenu.prevent="" controlsList="nodownload" loop muted autoplay playsinline width="1920" height="540">
                <source src="https://assets.friendlydiamonds.com/fdl/static-video/about_us_cropped.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <div class="video_block">
                <div class="video_text">
                    <div class="logo">
                        <img src="~/assets/landing/about/logo_white.png" alt="friendly-logo" width="135" height="120">
                    </div>
                    <div class="text">
                        <h1 class="font-active">The ‘Friendly’ Universe</h1>
                        <h4 class="mb-0">FOR A FRIENDLIER TOMORROW</h4>
                    </div>
                </div>
                
                <div class="para text-center for_desktop ">
                    <p>We are more than a jewelry brand; we are a community of dreamers, change-makers, and storytellers. Our<br> lab-grown diamond jewelry is crafted with care and worn with love. Embracing beauty and responsibility, we<br> are committed to Earth-kind practices.</p>
                </div>
            </div>
        </div>
        
        <div class="for_mobile">
            <p>We are more than a jewelry brand; we are a community of dreamers, change-makers, and storytellers. Our
                lab-grown diamond jewelry is crafted with care and worn with love. Embracing beauty and responsibility,
                we are committed to Earth-kind practices.</p>
        </div>

        <div class="container">

            <div class="links text-center mt-5 mt-md-2">
                <div class="textbox" @click="showBox('story')">
                    <span :class="{
                        text1: visibleBox === 'story',
                        reverseText1: previousBox === 'story',
                        animate: true
                    }">
                        THE STORY SO FAR
                    </span>
                    <span :class="[
                        {
                        text2: visibleBox === 'story',
                        reverseText2: previousBox === 'story',
                        animate: true
                        },
                        visibleBox === 'story' ? 'active' : 'inactive' 
                    ]">
                        THE STORY SO FAR
                    </span>
                </div>

                <div class="textbox" @click="showBox('diamonds')">
                    <span :class="{
                        text1: visibleBox === 'diamonds',
                        reverseText1: previousBox === 'diamonds',
                        animate: true
                    }">
                        ETHICAL & CONFLICT FREE DIAMONDS
                    </span>
                    <span :class="[
                        {
                        text2: visibleBox === 'diamonds',
                        reverseText2: previousBox === 'diamonds',
                        animate: true
                        },
                        visibleBox === 'diamonds' ? 'active' : 'inactive' 
                    ]">
                        ETHICAL & CONFLICT FREE DIAMONDS
                    </span>
                </div>

                <div class="textbox" @click="showBox('difference')">
                    <span :class="{
                        text1: visibleBox === 'difference',
                        reverseText1: previousBox === 'difference',
                        animate: true
                    }">
                        THE FRIENDLY DIFFERENCE
                    </span>
                    <span :class="[
                        {
                        text2: visibleBox === 'difference',
                        reverseText2: previousBox === 'difference',
                        animate: true
                        },
                        visibleBox === 'difference' ? 'active' : 'inactive' 
                    ]">
                        THE FRIENDLY DIFFERENCE
                    </span>
                </div>

                <div class="textbox" @click="showBox('share')">
                    <span :class="{
                        text1: visibleBox === 'share',
                        reverseText1: previousBox === 'share',
                        animate: true
                    }">
                        GIVING BACK TO THE COMMUNITY
                    </span>
                    <span :class="[
                        {
                        text2: visibleBox === 'share',
                        reverseText2: previousBox === 'share',
                        animate: true
                        },
                        visibleBox === 'share' ? 'active' : 'inactive' 
                    ]">
                        GIVING BACK TO THE COMMUNITY 
                    </span>
                </div>

                <div class="textbox" @click="showBox('planet')" v-if="$country.evertreen">
                    <span :class="{
                        text1: visibleBox === 'planet',
                        reverseText1: previousBox === 'planet',
                        animate: true
                    }">
                        GIVING BACK TO OUR PLANET
                    </span>
                    <span :class="[
                        {
                        text2: visibleBox === 'planet',
                        reverseText2: previousBox === 'planet',
                        animate: true
                        },
                        visibleBox === 'planet' ? 'active' : 'inactive' 
                    ]">
                        GIVING BACK TO OUR PLANET
                    </span>
                </div>
            </div>



            <div id="story" class="row align-items-center mt-4 mb-4 block">
                <div class="col-12 col-md-12 col-lg-6">
                    <picture>
                        <source width="1470" height="1000" type="image/webp" srcset="~/assets/landing/about/image1.webp">
                        <img class="radious_eight" alt="How are lab diamonds made" loading="lazy" width="1470" height="1000" type="image/jpeg" src="~/assets/landing/about/image1.jpg">
                    </picture>
                </div>
                <div class="col-12 col-md-12  col-lg-6 content">
                    <h5 class="font-active">The ‘Friendly’ Evolution</h5>
                    <h6><span>FOR A FRIENDLIER</span>&nbsp;TOMORROW</h6>
                    <p>Welcome to the ‘Friendly’ Evolution- where we focus on creating a <i>friendlier</i> tomorrow. Since 2017, we’re dedicated to making the world of diamonds more accessible, ethical, and sustainable. Join us in transforming the jewelry industry with innovation, personalization, and a dedication to leaving a positive impact on our planet.</p>
                    <NuxtLink class="com_btn" :to="localePath({ name:'our-story'})">
                        DISCOVER OUR STORY 
                    </NuxtLink>
                </div>      
            </div>
            <div id="diamonds" class="row align-items-center mt-5 mb-5 block">
                <div class="col-12 col-md-12  col-lg-6">
                    <picture>
                        <source width="1470" height="1000" type="image/webp" srcset="~/assets/landing/about/image2.webp">
                        <img class="radious_eight" alt="How are lab diamonds made" loading="lazy" width="1470" height="1000" type="image/jpeg" src="~/assets/landing/about/image2.jpg">
                    </picture>
                </div>
                <div class="col-12 col-md-12  col-lg-6 content">
                    <h5 class="font-active">The ‘Friendly’ Diamond</h5>
                    <h6><span>FOR A FRIENDLIER</span>&nbsp;SPARKLE</h6>
                    <p>We’re not just showcasing stunning diamonds- we’re sharing how our diamonds embody ethical practices, environmental care, and community support. Discover the science and innovation behind our Earth-kind diamonds, and see how your choices can create a friendlier sparkle.</p>
                    <NuxtLink class="com_btn" :to="localePath({ name:'ethical-and-conflict-free-diamonds'})">
                        LEARN MORE 
                    </NuxtLink>
                </div>
            </div>
            <div id="difference" class="row align-items-center mt-5 mb-5 block">
                <div class="col-12 col-md-12  col-lg-6">
                    <img class="radious_eight" alt="How are lab diamonds made" loading="lazy" width="735" height="500" type="image/jpeg" src="https://assets.friendlydiamonds.com/fdl/fd_gif/testt.gif">
                </div>
                <div class="col-12 col-md-12  col-lg-6 content">
                    <h5 class="font-active">The ‘Friendly’ Service</h5>
                    <h6><span>FOR A FRIENDLIER</span>&nbsp;EXPERIENCE</h6>
                    <p>We ensure exceptional service, personalized experience, and your satisfaction at Friendly Diamonds. We are here to make your journey enjoyable, stress-free, and memorable. Whether you are new to lab-grown diamonds or a seasoned shopper, our expert team is dedicated to guiding you through every stage, from selection to celebration.</p>
                    <NuxtLink class="com_btn" :to="localePath({ name:'friendly-diamond-difference'})">
                        KNOW MORE 
                    </NuxtLink>
                </div>
            </div>
            <div id="share" class="row align-items-center mt-5 mb-5 block">
                <div class="col-12 col-md-12  col-lg-6">
                    <img class="radious_eight" alt="How are lab diamonds made" loading="lazy" width="1470" height="1000" type="image/jpeg" src="https://assets.friendlydiamonds.com/fdl/fd_gif/4.gif">
                </div>
                <div class="col-12 col-md-12  col-lg-6 content">
                    <h5 class="font-active">The ‘Friendly’ Share of Care</h5>
                    <h6><span>FOR A FRIENDLIER</span>&nbsp;FUTURE</h6>
                    <p class="info">An estimated 150 million children worldwide are orphans (UNICEF).</p>
                    <p class="info1">This staggering number shook us, and we knew we had to be the change.</p>
                    <p>There is more to us than just jewelry; we are dedicated to making a positive impact by collaborating with Abundant Life Ministry to transform lives of underprivileged children. As part of this initiative, we provide educational opportunities, essential resources, and hope for a brighter future.</p>
                    <NuxtLink class="com_btn" :to="localePath({ name:'our-share-of-care'})">
                        KNOW MORE 
                    </NuxtLink>
                </div>
            </div>
            <div id="planet" class="row align-items-center mt-5 mb-5 block" v-if="$country.evertreen">
                <div class="col-12 col-md-12  col-lg-6 text-center">
                    <video @contextmenu.prevent="" controlsList="nodownload" loop muted autoplay playsinline width="630" height="354">
                        <source src="https://assets.friendlydiamonds.com/fdl/static-video/vid.mp4" type="video/mp4">
                    </video>
                </div>
                <div class="col-12 col-md-12  col-lg-6 content">
                    <h5 class="font-active">The ‘Friendly’ Green Imprint</h5>
                    <h6><span>FOR A FRIENDLIER</span>&nbsp;PLANET</h6>
                    <p>Caring for our planet is the heartbeat of our mission at Friendly Diamonds and we are proud to announce our initiative with Evertreen; a platform dedicated to reinforcing the ecosystem. For every purchase made on our website, we plant trees in various regions of Africa. Join us in creating a greener world with our Earth-kind choices!</p>
                    <NuxtLink class="com_btn" :to="localePath({ name:'green-and-sustainable-gift'})">
                        ADD TO OUR FOREST
                    </NuxtLink>
                </div>
            </div>
        </div>
    </div>

</template>


<script setup>
    useFetchMeta(useNuxtApp(), useRuntimeConfig());
    const localePath = useLocalePath();
    const visibleBox = ref('story');
    const previousBox = ref(''); 
    const { $country} = useNuxtApp()

    const showBox = (box) => {
    if (visibleBox.value !== box) {
        previousBox.value = visibleBox.value;
        visibleBox.value = box;

        // Scroll to the section with the matching ID
        const element = document.getElementById(box);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center'  });
        }
    }
};
</script>


<style scoped>

    video {
        max-width: 100%;
        height: auto;
        clip-path: inset(0);
    }

    .video_box {
        position: relative;
        margin-bottom: 2%;
    }

    .video_block {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }

    .video_text{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 40px;
    }

    .video_text h1 {
        font-size: 60px;
        color: #ffff;
        margin-bottom: 16px;
    }

    .video_text h4 {
        font-size: 24px;
        letter-spacing: 4px;
        color: #ffff;
    }
    .para {
        color: #ffff;
        font-size: 16px;
        margin-top: 20px;
    }

    .links {
        display: flex;
        justify-content: center;
        gap: 10px 0;
        flex-wrap: wrap;
        position: sticky;
        top: 0;
        padding: 16px 0;
        background: #fff;
        z-index: 1;
    }

    .links.small-gap {
        gap: 5px;
    }

    /* 
    .links span {
        font-size: 16px;
        color: #353535;
        letter-spacing: 1px;
        padding: 0 23px;
    
    } */
    .border-right-visible{
        border-right: none;
    }
    .textbox span{
        letter-spacing: 2px;
    }
    .textbox span.active {
        text-decoration: underline;
        color: var(--green);
    }

    .links span:hover {
        cursor: pointer;
    }

    .textbox:nth-last-child(1){
        border-right: none;
    }

    .border-right-visible {
        border-right: 2px solid #c4c4c4;
    }

    /* .links span:nth-last-child(3){
        border-right: none;
    } */

    .links span:nth-last-child(1):not(.border-right-adjust) {
        border-right: none;
    }
    .content {
        padding-left: 5%;
    }
    .content a {
        cursor: pointer;
    }
    .content h5{
        font-size: 32px;
    }

    .content h6 {
        font-size: 20px;
        letter-spacing: 2px;
    }

    .content h6 span {
        color: var(--green);
    }

    .content p {
        font-size: 16px;
        color: #606060;
        margin: 32px 0;
    }

    .content .info {
        margin: 4% 0 1% 0;
    }

    .content .info1 {
        margin: 1% 0 1% 0;
    }

    .com_btn {
        border: 1px solid #212529;
        padding: 14px 43px;
        border-radius: 4px;
        font-size: 14px;
        color: #212529;
        letter-spacing: 1.4px;
        font-weight: 600;
        text-align: center;
        width: max-content;
        display: block;
    }

    .svg-head {
        height: 16px;
        width: 20px;
        opacity: 0;
    }
    .com_btn:hover .svg-head{
        opacity: 1;
        
    }

    .block img {
        border-radius: 8px;
    }

    .block video {
        border-radius: 8px;
    }

/* Main IMP Animaiton */

.active {
    text-decoration: underline;
    color: var(--green);
}

.textbox {
    display: flex;
    flex-direction: column;
    height: 25px;
    overflow: hidden;
    align-items: center;
    padding: 0 15px;
    border-right: 1px solid black;
}

.textbox:nth-child(3),
.textbox:nth-child(5) {
    border-right: none;
}

.textbox3{
    position: relative;
    width: 100%;
    height: 200px;
    overflow: hidden;
}

.textbox3 p {
    position: absolute;
    animation-duration: 0.7s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;    
}

.textbox span {
    display: block;
    width: 100%;
    text-align: center;
    animation-duration: 0.7s;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;
    transform: translateY(0);
    opacity: 1;
}


.text1 {
    transform: translateY(0); 
}

.text2 {
    transform: translateY(100%); 
}


.inactive {
    animation-name: slideDownReverse;
}


.active {

    animation: none; 
}

/* Current box animation */
.animate.text1 {
    animation-name: slideUp;
}

.animate.text2 {
    animation-name: slideDown;
}

/* Previous box reverse animations */
.reverseText1 {
    animation-name: slideDownReverse;
}
span.animate.inactive{
    animation-name: slideDownReverse;
}
.reverseText2 {
    animation-name: slideUpReverse;
}

/* Current box span1 moves up and out */
@keyframes slideUp {
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(-80%);
    }
}

/* Current box span2 moves in from below */
@keyframes slideDown {
    0% {
        transform: translateY(75%);
    }
    100% {
        transform: translateY(-100%);
    }
}

/* Previous box span1 moves back into view */
@keyframes slideDownReverse {
    0% {
        transform: translateY(-100%);
    }
    
    100% {
        transform: translateY(0%);
    }
}

/* Previous box span2 moves out of view downwards */
@keyframes slideUpReverse {
    0% {
        transform: translateY(20%);
    }
    100% {
        transform: translateY(100%);
    }
}


/* responsvie */
@media (max-width: 1200px) {
    .video_text h1 {
        font-size: 50px;
    }
    .video_text h4 {
        font-size: 22px;
        letter-spacing: 3px;
    }
    .logo img {
        width: 110px;
    }

    .video_text {
        gap: 35px;
    }
    .para {
        font-size: 15px;
    }

    .textbox {
        border-right: 2px solid #c4c4c4;
    }
    .textbox:nth-child(4){
        border-right: 2px solid #c4c4c4;
    }
    .content {
        padding-left: 3%;
    }
}
@media (max-width: 1024px) {
    .links{
        top: 50px;
    }
}    

@media(max-width:992px) {
    .video_text h1 {
        font-size: 38px;
    }   
    .links {
        display: none;

    }
    .video_text h4{
        font-size: 18px;
    }
    .video_text {
        gap: 25px;
    }
    .logo img {
        width: 90px;
    }
    .links {
        gap:8px;
    }
    .links span {
        font-size: 14px;
        letter-spacing: 1px;
        padding: 0 8px;
    }
    .content {
        padding-left: 2%;
    }
    .block img {
        margin-bottom: 20px;
    }

    .block video {
        margin-bottom: 20px;
    }
    .para br {
        display: none;
    }
    .para{
        padding: 0 20%;
        font-size: 14px;
    }    
    .textbox {
        border-right: 2px solid #c4c4c4;
    }

}


@media(max-width:767px) {
    .video_box video {
        height: 60vh ;
        object-fit: cover;
    }
    .links {
        flex-direction: column;
        margin-bottom: 50px;
        position: static;
    }
    .textbox{
      border-right: none;
    }
    .textbox:nth-child(4){
        border-right: none;
    }
    .links span {
        border-right: none;
        /* margin-bottom: 8px; */
        font-size: 14px;
        letter-spacing: 1px;
    }
    .content {
        padding-left: 3%;
    }
    .content h5 {
        font-size: 24px;
    }

    .content h6 {
        font-size: 16px;
    }

    .content p {
        font-size: 14px;
        margin: 16px 0;
    }
    /* .com_btn {
       width: 60%;
    } */
    .hide-br {
        display: none;
    }
    .text h1{
        font-size: 24px;
        margin-bottom: 4px;
    }
    .text h4{
        font-size: 14px;
        letter-spacing: 1.5px;
        margin-bottom: 0;
    }
    .for_mobile {
        font-size: 14px;
        color: #606060;
        text-align: center;
        padding: 0 16px;
        margin-bottom: 5%;
    }

    .video_text {
        gap: 12px;
    }
    .logo img {
        width: 60px;
    }
    .block {
        margin-bottom: 50px !important;
    }
    .block img {
        border-radius: 4px;
    }

    .block video {
        border-radius: 4px;
    }
    .com_btn {
        padding: 14px 30px;
    }
}
</style>